import axios from "axios";
const REST_API_BASE_URL = 'http://localhost:8080/webnet-hms/api/insBooks';
export const AddDepartmentSer =(formData) => axios.post(REST_API_BASE_URL,formData);
